import { resolveAllergen, type Dish, type DishI18nEntry } from "@arfood/shared";

export function el(tag: string, className?: string): HTMLElement {
  const e = document.createElement(tag);
  if (className) e.className = className;
  return e;
}

export function actionButton(className: string, action: "ar" | "order" | "details", label: string): HTMLButtonElement {
  const b = document.createElement("button");
  b.type = "button";
  b.className = className;
  b.dataset["action"] = action;
  b.textContent = label;
  return b;
}

export function pickI18n(dish: Dish, lang: string): DishI18nEntry {
  const entry = dish.i18n[lang];
  if (entry) return entry;
  const first = Object.values(dish.i18n)[0];
  return first ?? { name: dish.id, desc: "" };
}

const priceFmt = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

export function formatPrice(cents: number): string {
  return priceFmt.format(cents / 100);
}

export function allergensLine(allergens: string[]): string {
  return allergens.length ? `Allergene: ${allergens.join(", ")}` : "";
}

// Kurz-Chips für Karten (Code + Kurzname via LMIV-Katalog; Alt-Strings als Rohtext).
export function allergenChips(allergens: string[], lang: string): HTMLElement | null {
  if (!allergens.length) return null;
  const wrap = el("div", "dish-allergens");
  for (const a of allergens) {
    const chip = el("span", "allergen-chip");
    chip.textContent = resolveAllergen(a, lang).short;
    wrap.appendChild(chip);
  }
  return wrap;
}
